import * as React from "react";
import ImageAvatar from "../../../ImageAvatar";
import VideoAvatar from "./VideoAvatar";

const ShopVideo = React.memo(function ShopVideo({ influencer }) {
  if (!influencer) return null;
  if (influencer.hasVideoAvatar) {
    return <VideoAvatar influencer={influencer} />;
  }

  return <ImageAvatar influencer={influencer} />;
});

export default ShopVideo;
